








import { defineComponent } from "@vue/composition-api";
import { RubricVersionStatus } from "@/generated/api.clients";

export default defineComponent({
  props: {
    status: {
      type: Number,
      required: true
    }
  },
  setup(props) {
    return {
      RubricVersionStatus
    }
  }
});
